import { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Popover } from 'antd';
import { useStore } from '../../store/store';
import ConfigurationModal from '../RightSide/configurationModal/ConfigurationModal';
import { iconButtonStyle } from '../../utils/styles';
import { BORDER_GRAY, getPrimaryDark } from '../../constants/constants';
import { NavbarButton } from './NavbarButton';
import { Separator } from './Separator';
import SearchReplacePopover from '../common/SearchReplacePopover';
import SaveIndicator from '../common/SaveIndicator';

const selector = (state) => ({
  isAdmin: state?.user?.isAdmin,
  setBoxMovable: state.setBoxMovable,
  isTemplate: state.currentDocument?.type === 'template',
  // Autosave affiché pour un admin (tout doc) ou un commercial sur opportunité/offre.
  canSave:
    !!state?.user?.isAdmin ||
    state.currentDocument?.type === 'opportunity' ||
    state.currentDocument?.type === 'offer',
});

export const RightPropertiesComponent = ({
  configurationPanelVisible,
  setConfigurationPanelVisible,
  configurationTab,
  setConfigurationTab
}) => {
  const {
    isAdmin,
    setBoxMovable,
    isTemplate,
    canSave,
  } = useStore(selector);
  const [searchPopoverVisible, setSearchPopoverVisible] = useState(false);

  useEffect(() => {
    setBoxMovable(!configurationPanelVisible);
  }, [configurationPanelVisible, setBoxMovable]);

  return (
    <>
      {isAdmin && configurationPanelVisible && (
        <ConfigurationModal
          open={true}
          handleOk={() => {
            setConfigurationTab('Couleurs');
            setConfigurationPanelVisible(false);
          }}
          configurationTab={configurationTab}
          setConfigurationTab={setConfigurationTab}
        />
      )}
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        {/* Indicateur d'enregistrement : placé à gauche de « Rechercher / Remplacer »
            pour ne pas surcharger le bloc identité (gauche) de la navbar. */}
        {canSave && (
          <SaveIndicator style={{ fontSize: 11, marginRight: 10, color: getPrimaryDark(isTemplate) }} />
        )}
        {/* Search/Replace popover */}
        <Popover
          content={<SearchReplacePopover onClose={() => setSearchPopoverVisible(false)} />}
          trigger="click"
          placement='bottom'
          open={searchPopoverVisible}
          onOpenChange={(visible) => {
            if (!visible) {
              // Effacer les surlignages quand on ferme le popover (clic extérieur)
              try {
                const s = require('../../store/store').useStore.getState();
                s.clearSearchResults();
                s.setSearchSelectionActive(false);
              } catch (e) { }
            }
            setSearchPopoverVisible(visible)
          }}
          getPopupContainer={(trigger) => trigger.parentElement}
          styles={{ body: { pointerEvents: 'auto' } }}
        >
          <div>
            <NavbarButton
              tooltipContent={'Rechercher / Remplacer'}
              icon={<FontAwesomeIcon icon={icon({ name: 'magnifying-glass', family: 'duotone', style: 'solid' })} style={iconButtonStyle()} />}
              onClick={() => setSearchPopoverVisible(true)}
            />
          </div>
        </Popover>
        {/* Bouton Configuration déplacé dans l'onglet "Paramètres" du panel
            gauche (cf. SettingsPanel). La modale reste rendue ici, pilotée par
            configurationPanelVisible (logique collab dans Navbar). */}
        <Separator color={BORDER_GRAY} />
      </div>
    </>
  );
};
